import { Divider, Grid } from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionContactsVM } from 'practice/view-models/practice-detail';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';

interface FormProps {
  disabled?: boolean;
  onChange: (
    key: keyof AccordionContactsVM,
    value: AccordionContactsVM[keyof AccordionContactsVM]
  ) => void;
  values?: AccordionContactsVM;
  onSave: () => void;
}

const FormComponent = ({ disabled, onChange, values, onSave }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PmiTitleDivider>Modalità di contatto</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Telefono"
          aria-label="Telefono"
          id="telephone"
          name="telephone"
          fullWidth
          type="text"
          disabled={disabled}
          variant="outlined"
          value={values?.telephone || ''}
          onChange={(event) => onChange('telephone', event.target.value)}
          inputProps={{ maxLength: '10' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Cellulare"
          aria-label="Cellulare"
          id="mobilePhone"
          name="mobilePhone"
          fullWidth
          type="text"
          disabled={disabled}
          variant="outlined"
          value={values?.mobilePhone || ''}
          onChange={(event) => onChange('mobilePhone', event.target.value)}
          inputProps={{ maxLength: '11' }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="E-mail"
          aria-label="E-mail"
          id="email"
          name="email"
          fullWidth
          type="text"
          disabled={disabled}
          variant="outlined"
          value={values?.email || ''}
          onChange={(event) => onChange('email', event.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="P.E.C."
          aria-label="P.E.C."
          id="pec"
          name="pec"
          fullWidth
          type="text"
          disabled={disabled}
          variant="outlined"
          value={values?.pec || ''}
          onChange={(event) => onChange('pec', event.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Note"
          aria-label="Note"
          id="note"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '240',
          }}
          value={values?.note || ''}
          onChange={(event) => {
            onChange('note', event?.target.value);
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiButton
          variant="outlined"
          color="cdmBrandThird"
          onClick={() => onSave()}
          disabled={disabled}
        >
          conferma
        </PmiButton>
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Practice Detail - Form - accordion contacts - form';

const Form = memo(FormComponent);

export default Form;
